import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-8 overflow-hidden rounded-xl border border-gray-200 bg-white" }
const _hoisted_2 = { class: "pt-6" }
const _hoisted_3 = { class: "flex items-center gap-4 px-6" }
const _hoisted_4 = { class: "text-lg font-semibold leading-6 tracking-tight text-gray-900" }
const _hoisted_5 = { class: "ml-auto shrink-0" }
const _hoisted_6 = {
  key: 0,
  class: "mt-3 px-6"
}
const _hoisted_7 = { class: "text-sm text-gray-500" }
const _hoisted_8 = { class: "mt-2 divide-y divide-gray-200" }


export default {
  __name: 'SettingCard',
  props: {
  name: { type: String, required: true },
  description: { type: String, default: '' }
},
  setup(__props) {

const props = __props

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(props.name), 1),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "action")
        ])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("hr", {
        class: "mt-3 border-gray-200",
        "aria-hidden": "true"
      }, null, -1)),
      (props.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(props.description), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

}